/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectTaskDependencyCommand } from '../../models/update-project-task-dependency-command';
import { UpdateProjectTaskDependencyCommandResult } from '../../models/update-project-task-dependency-command-result';

export interface ApiProjectTaskDependencyUpdateProjectTaskDependencyPost$Params {
      body?: UpdateProjectTaskDependencyCommand
}

export function apiProjectTaskDependencyUpdateProjectTaskDependencyPost(http: HttpClient, rootUrl: string, params?: ApiProjectTaskDependencyUpdateProjectTaskDependencyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectTaskDependencyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTaskDependencyUpdateProjectTaskDependencyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectTaskDependencyCommandResult>;
    })
  );
}

apiProjectTaskDependencyUpdateProjectTaskDependencyPost.PATH = '/api/ProjectTaskDependency/UpdateProjectTaskDependency';
